import { render, staticRenderFns } from "./DeviceNote.vue?vue&type=template&id=be4c04e6"
import script from "./DeviceNote.vue?vue&type=script&lang=js"
export * from "./DeviceNote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports